module.exports = __webpack_public_path__ + "static/media/ko-KR.e9bb78fe.md";